export const logoStoom = '/assets/logo.png'
export const logoSecondaryStoom = '/assets/logo-white.png'
export const logoMiniStoom = '/assets/logo-mini.png'
export const logoFaviconStoom = '/assets/favicon.png'

export const logoAmerinode = '/assets/logo-amerinode.png'
export const logoMiniAmerinode = '/assets/logo-amerinode-mini.png'
